import UnhandledError from "./UnhandledError";
import { Component, ReactNode } from "react";
import { logger } from "logger";
import * as Sentry from "@sentry/react";

export class TopLevelBoundary extends Component<
  { children: ReactNode },
  {
    error: string | null | Error;
  }
> {
  constructor(props: { children: ReactNode }) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error: Error) {
    return { error };
  }

  componentDidCatch(error: Error, errorInfo: { componentStack: string }) {
    Sentry.captureException(error);

    logger.error("Fatal error in component tree", {
      error,
      errorName: error.name,
      errorMessage: error.message,
      errorStack: error.stack,
      componentStack: errorInfo.componentStack
    });
  }

  render() {
    if (this.state.error)
      //render fallback UI
      return (
        <UnhandledError
          errorMessage={this.state.error + ""}
          retryText="Please reload the app from this page"
          activityText="Something went wrong."
        />
      );
    //when there's not an error, render children untouched
    else return this.props.children;
  }
}
